var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;stroke:#000000;stroke-linecap:round;stroke-miterlimit:10;}\r\n\t.st1{fill:none;stroke:#000000;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 19.2,
    y1: 8.2,
    x2: 4.8,
    y2: 8.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 19.2,
    y1: 13.1,
    x2: 4.8,
    y2: 13.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.1,
    cy: 16.4,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15.9,
    cy: 16.4,
    r: 1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 7.1,
    y1: 19.6,
    x2: 5.6,
    y2: 21.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 18.4,
    y1: 21.3,
    x2: 17,
    y2: 19.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M15.2,4.2V3.8c0-0.6-0.5-1.1-1.1-1.1H10c-0.6,0-1.1,0.5-1.1,1.1v0.4h-1c-1.7,0-3.1,1.4-3.1,3.1v9.3 c0,1.7,1.4,3.1,3.1,3.1h8.3c1.7,0,3.1-1.4,3.1-3.1V7.3c0-1.7-1.4-3.1-3.1-3.1H15.2z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrain);
export default __webpack_public_path__ + "static/media/train.73425f857c815724b9a4faf2459552c9.svg";
export { ForwardRef as ReactComponent };